var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Intro = void 0;
var Intro_1 = __importDefault(require("./Intro"));
exports.Intro = Intro_1.default;
exports.default = Intro_1.default;
//# sourceMappingURL=index.js.map